import WavyLoader from "components/v2/WavyLoader";
import { Container } from "layouts";
import PaddingX from "layouts/PaddingX";

const BookPageLoader = () => {
	return (
		<Container>
			<PaddingX>
				<div className="max-w-7xl mx-auto pt-8 md:pt-10 pb-[calc(3.5rem+env(safe-area-inset-bottom,0px))] overflow-x-hidden">
					<div className="mb-5 md:mb-7">
						<WavyLoader width="220px" height="18px" />
					</div>

					<div className="grid grid-cols-1 lg:grid-cols-12 gap-4 sm:gap-6 md:gap-8">
						<div className="lg:col-span-8 grid grid-cols-1 md:grid-cols-12 gap-4 sm:gap-6 md:gap-8 min-w-0">
							<div className="md:col-span-4 flex justify-center min-w-0">
								<div
									className="w-full max-w-[200px] xxs:max-w-[240px] xs:max-w-[260px] sm:max-w-[280px] md:max-w-[300px] rounded-3xl overflow-hidden"
									style={{ aspectRatio: "3/4" }}
								>
									<WavyLoader width="100%" height="100%" className="rounded-3xl" />
								</div>
							</div>

							<div className="md:col-span-8 flex flex-col gap-5 min-w-0">
								<div className="rounded-2xl border border-gray-100 p-5 md:p-7">
									<WavyLoader width="160px" height="20px" />
									<div className="mt-4">
										<WavyLoader width="100%" height="36px" />
									</div>
									<div className="mt-4 flex gap-3">
										<WavyLoader width="160px" height="20px" />
										<WavyLoader width="140px" height="20px" />
									</div>
								</div>

								<div className="lg:hidden rounded-2xl border border-gray-100 p-4 md:p-6">
									<WavyLoader width="100%" height="360px" className="rounded-2xl" />
								</div>

								<div className="rounded-2xl border border-gray-100 p-5 md:p-7">
									<WavyLoader width="140px" height="24px" />
									<div className="mt-4 space-y-2">
										<WavyLoader width="100%" height="16px" />
										<WavyLoader width="95%" height="16px" />
										<WavyLoader width="92%" height="16px" />
										<WavyLoader width="96%" height="16px" />
									</div>
								</div>
							</div>
						</div>

						<div className="hidden lg:block lg:col-span-4">
							<WavyLoader width="100%" height="500px" className="rounded-2xl" />
						</div>
					</div>
				</div>
			</PaddingX>
		</Container>
	);
};

export default BookPageLoader;
